import styled, { keyframes } from 'styled-components';
import {Colors} from "@shared/styles/colors";

// 애니메이션 정의
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// 모달 배경
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
`;

// 모달 내용
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 300px;
  width: 90%;
  
`;

// 로딩 인디케이터 영역
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;

// 로딩 스피너
const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

const TitleText = styled.div`
  font-size: 18px;
  font-family: Pretendard-Bold, emoji;
  color : ${Colors.boldTextColor};
`
const ContentText = styled.div`
  font-size: 16px;
  font-family: Pretendard-Bold, emoji;
  color : ${Colors.greyColor};
`
// 닫기 버튼
const CloseButton = styled.button`
  background: #3498db;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background: #2980b9;
  }
`;

export const s = {
    ModalOverlay,
    ModalContent,
    LoadingContainer,
    Spinner,
    CloseButton,
    TitleText,
    ContentText
}
